import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {EPDCERTIFICATION, Material, MATERIALHEALTHSAFETY} from "../material/materialDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";
import {MaterialUsageGroup} from "../material/materialUsageGroup";

@entityConfig()
export class ProjectVersionMaterial extends DomainAncestor {
  @observable materialId: number;
  @observable name: string;
  @observable code: string;
  @observable density: number;
  @observable mass: number;
  @observable primaryEnergy: number;
  @observable co2Equivalent: number;
  @observable so2Equivalent: number;
  @observable po4Equivalent: number;
  @observable r11Equivalent: number;
  @observable c2h4Equivalent: number;
  @observable thermalCoefficient: number;
  @observable renewableWeight: number;
  @observable recycledWeight: number;
  @observable regionallyMadeWeight: number;
  @observable area: number;
  @observable volume: number;
  @observable lifespan: number;
  @observable woodBased : boolean;
  @observable epdcertification : LovItem<EPDCERTIFICATION>;
  @observable epdCertificationWeight : number;
  @observable pefcCertificationWeight : number;
  @observable pefcRequestWeight : number;
  @observable fscCertificationWeight : number;
  @observable fscRequestWeight : number;
  @observable healthSafetyRequirement : LovItem<MATERIALHEALTHSAFETY>;
  @observable comment : string;
  @observable originalMaterial: LovItem<Material>;
  @observable projectVersion : LovItem;
  @observable materialUsageGroup : LovItem<MaterialUsageGroup>;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.materialId;
  }

  public setId(id: ID): void {
    this.materialId = <number>id;
  }
}




// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionMaterialDomain.ts